import React from 'react';

const BtnLoading = () => {
  return (
    <div className="arh-flex arh-justify-center arh-items-center arh-size-full arh-h-18">
      <span className={`arh-size-2 arh-ms-2 arh-animate-[wave_1.3s_ease-in-out_infinite] arh-rounded-full arh-bg-white`}></span>
      <span className={`arh-size-2 arh-ms-2 arh-animate-[wave_1.3s_-1.1s_ease-in-out_infinite] arh-rounded-full arh-bg-white`}></span>
      <span className={`arh-size-2 arh-ms-2 arh-animate-[wave_1.3s_-0.9s_ease-in-out_infinite] arh-rounded-full arh-bg-white`}></span>
    </div>
  )
}

export default BtnLoading;